module.exports = __webpack_public_path__ + "static/media/stage_6.1f884646.png";